var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgD28SocialFacebook = function SvgD28SocialFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#EFEFF3",
    cx: 14,
    cy: 14,
    r: 14
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.103 14.378h1.807v7.437c0 .147.119.266.266.266h3.063a.266.266 0 0 0 .266-.266v-7.402h2.076a.266.266 0 0 0 .264-.236l.316-2.738a.266.266 0 0 0-.264-.296h-2.392V9.427c0-.518.278-.78.828-.78h1.564a.266.266 0 0 0 .266-.266V5.868a.266.266 0 0 0-.266-.266H15.74l-.098-.002c-.374 0-1.674.073-2.701 1.018-1.138 1.047-.98 2.3-.942 2.518v2.007h-1.897a.266.266 0 0 0-.266.266v2.703c0 .147.12.266.266.266z",
    fill: "#000",
    fillRule: "nonzero"
  }))));
};
export default SvgD28SocialFacebook;